import { Component, Input } from '@angular/core';

import { MessageConstant } from '../../Constant';

import { AuthService } from '../../service/auth.service';
import { EventService } from '../../service/event.service';

@Component({
    selector: 'app-createdir-modal',
    templateUrl: './createdir-modal.page.html',
    styleUrls: ['./createdir-modal.page.scss'],
})
export class CreatedirModalPage
{
    private isdisabled = true;
    private name = "";
    private error = "";

    constructor(
        private auth: AuthService,
        private event: EventService
    )
    {
    }

    async ngOnInit()
    {
        this.event.modal_subject.next({key: "modalSubscribe", id: 'createdir-modal', value: null});
    }

    async createDirSend()
    {
        if (this.isdisabled === true) {
            return;
        }
        this.event.modal_subject.next({key: "closeModal", id: 'createdir-modal', value: { name: this.name }});
    }

    async createDirOnChange(event)
    {
        this.name = event.target.value;

        if (this.auth.empty(this.name)) {
            this.isdisabled = true;
            return;
        } else {
            this.isdisabled = false;
        }

        if (!this.auth.isSafeCharactor(event.target.value, 0)) {
            this.isdisabled = true;
            this.error = MessageConstant.FORBIDDEN_CHAR_ERR;
            return;
        }

        this.error = "";
    }

    async createDirClose()
    {
        this.event.modal_subject.next({key: "closeModal", id: 'createdir-modal', value: null});
    }
}
